import React, { useState, useEffect } from 'react';
import '../personal-info/personal-info.css';
import {
  FaUser, FaPhone, FaEnvelope, FaCalendarAlt,
  FaIdCard, FaFileUpload
} from 'react-icons/fa';
import { createPersonalInfo, getPersonalInfo } from '../../../services/candidate/api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PersonalInfoForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    fatherName: '',
    dateOfBirth: '',
    email: '',
    gender: 'Male',
    mobileNumber: '',
    alternateMobileNumber: '',
    aadhaarCardNumber: '',
    personalImage: null,
    personalImageFileName: '',
    imagePreview: ''
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hasApiData, setHasApiData] = useState(false);


  useEffect(() => {
    const fetchAndSetPersonalInfo = async () => {
      setLoading(true);
      setError(null);
      try {
        let sessionData = null;
        const personalResponseStored = localStorage.getItem('personal_response');
        if (personalResponseStored) {
          try {
            sessionData = JSON.parse(personalResponseStored);
            localStorage.removeItem('personal_response');
          } catch (e) {
            console.error('Invalid JSON in localStorage:', e);
          }
        }

        let apiData = null;
        if (!sessionData) {
          try {            const fetchedData = await getPersonalInfo();
            apiData = fetchedData?.data?.data || null;
          } catch (err) {
            if (err.response && err.response.status === 404) {
              console.warn('No data from API, form remains empty.');
            } else {
              console.error('Error fetching personal info:', err);
              setError('Failed to load personal information. Please try again.');
            }
          }
        }

        const dataToUse = sessionData || apiData;
        if (dataToUse) {
         // setHasApiData(true);
          let updatedForm = { ...formData };
debugger
          // --- MAPPING LOGIC FOR SESSION DATA (LOCAL STORAGE) ---
          if (sessionData) {
            const fullName = sessionData.full_name?.split(' ');
            updatedForm.firstName = fullName?.[0] || '';
            updatedForm.lastName = fullName?.slice(1).join(' ') || '';
            updatedForm.fatherName = sessionData.care_of?.replace('S/O ', '') || '';
            updatedForm.dateOfBirth = sessionData.dob || '';
            updatedForm.gender = sessionData.gender === 'M' ? 'Male' : (sessionData.gender === 'F' ? 'Female' : 'Other');
            updatedForm.aadhaarCardNumber = sessionData.aadhaar_number || '';
            // updatedForm.imagePreview = `data:image/jpeg;base64,${sessionData.profile_image}`;
            if (sessionData.profile_image) {
              try {
                const base64Data = sessionData.profile_image;
                const byteString = atob(base64Data);
                const ab = new ArrayBuffer(byteString.length);
                const ia = new Uint8Array(ab);
                for (let i = 0; i < byteString.length; i++) {
                  ia[i] = byteString.charCodeAt(i);
                }
                const blob = new Blob([ab], { type: 'image/jpeg' }); // Or 'image/png' based on source
                const file = new File([blob], 'profile.jpg', { type: 'image/jpeg' });

                updatedForm.personalImage = file;
                updatedForm.personalImageFileName = 'profile.jpg';
                updatedForm.imagePreview = `data:image/jpeg;base64,${base64Data}`;
              } catch (error) {
                console.error('Error converting base64 to file:', error);
              }
            }

          }
          // --- MAPPING LOGIC FOR API DATA ---
          else if (apiData) {
            updatedForm.firstName = apiData.firstName || '';
            updatedForm.lastName = apiData.lastName || '';
            updatedForm.fatherName = apiData.fatherName || '';
            updatedForm.email = apiData.email || '';
            updatedForm.gender = apiData.gender || 'Male';
            updatedForm.mobileNumber = apiData.mobileNumber || '';
            updatedForm.alternateMobileNumber = apiData.alternateMobileNumber || '';
            updatedForm.aadhaarCardNumber = apiData.aadhaarCardNumber || '';
            updatedForm.dateOfBirth = apiData.dateOfBirth
              ? (() => {
                const [d, m, y] = apiData.dateOfBirth.split('-');
                return `${y}-${m}-${d}`;
              })()
              : '';

            if (apiData.personalImageFileName) {
              try {
                const response = await fetch(apiData.personalImageFileName);
                const blob = await response.blob();
                const fileName = apiData.personalImageFileName.substring(
                  apiData.personalImageFileName.lastIndexOf('/') + 1
                );
                const file = new File([blob], fileName, { type: blob.type });

                updatedForm.personalImage = file;
                updatedForm.personalImageFileName = fileName;
                updatedForm.imagePreview = apiData.personalImageFileName;
              } catch (imgErr) {
                console.error('Image fetch error:', imgErr);
              }
            }
          }
          setFormData(updatedForm);
        }
      } catch (finalErr) {
        console.error('Unexpected error:', finalErr);
        setError('An unexpected error occurred while loading your data.');
      } finally {
        setLoading(false);
      }
    };

    fetchAndSetPersonalInfo();
  }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    if (['firstName', 'lastName'].includes(name)) {
      updatedValue = value.replace(/[^a-zA-Z\s]/g, '');
    }
    if (name === 'fatherName') {
      updatedValue = value.replace(/[^a-zA-Z\s/]/g, '');
    }
    if (['mobileNumber', 'alternateMobileNumber'].includes(name)) {
      updatedValue = value.replace(/[^0-9]/g, '').slice(0, 10);
    }
    if (name === 'aadhaarCardNumber') {
      // Allow alphanumeric characters for Aadhaar
      updatedValue = value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 12);
    }

    setFormData(prev => ({ ...prev, [name]: updatedValue }));
  };

  const handleFileDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file && validateFile(file)) {
      const previewUrl = URL.createObjectURL(file);
      setFormData(prev => ({
        ...prev,
        personalImage: file,
        personalImageFileName: file.name,
        imagePreview: previewUrl
      }));
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file && validateFile(file)) {
      const previewUrl = URL.createObjectURL(file);
      setFormData(prev => ({
        ...prev,
        personalImage: file,
        personalImageFileName: file.name,
        imagePreview: previewUrl
      }));
    }
  };

  const validateFile = (file) => {
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (!allowedTypes.includes(file.type)) {
       toast.error('Please upload a valid image file (JPEG, PNG, or GIF).');
      return false;
    }
    if (file.size > maxSize) {
       toast.error('Image file size must be less than 5MB.');
      return false;
    }
    return true;
  };


  const validate = () => {
    const requiredFields = [
      'firstName',
      'lastName',
      'dateOfBirth',
      'email',
      'gender',
      'mobileNumber',
      'aadhaarCardNumber'
    ];

    const missingFields = requiredFields.filter(field => {
      const isFieldEmpty = !formData[field] || formData[field].toString().trim() === '';
      if (isFieldEmpty) {
        //console.log(`Validation failed: Field '${field}' is empty.`);
      }
      return isFieldEmpty;
    });

    const isImagePresent = formData.personalImage || formData.imagePreview;
    if (!isImagePresent) {
      missingFields.push('Photo'); // User-friendly name for  toast.error
      //console.log(`Validation failed: Missing personal image.`);
    }

    if (missingFields.length > 0) {
       toast.error(`Please fill the following required fields: ${missingFields.join(', ')}`);
      return false;
    }

    // if (!/^[A-Za-z\s]{1,40}$/.test(formData.firstName)) {
    //   //console.log('Validation failed: First name format incorrect.');
    //    toast.error('First name must contain only letters and spaces, up to 40 characters.');
    //   return false;
    // }
    // if (!/^[A-Za-z\s]{1,40}$/.test(formData.lastName)) {
    //   //console.log('Validation failed: Last name format incorrect.');
    //    toast.error('Last name must contain only letters and spaces, up to 40 characters.');
    //   return false;
    // }
    // if (!/^[A-Za-z\s/]{1,40}$/.test(formData.fatherName.trim())) {
    //   //console.log('Validation failed: Father/Spouse name format incorrect.');
    //    toast.error('Father/Spouse name can contain only alphabets, spaces, and \'/\' (max 40 characters).');
    //   return false;
    // }

    if (!/^\d{10}$/.test(formData.mobileNumber)) {
      //console.log('Validation failed: Mobile number format incorrect.');
       toast.error('Mobile number must be exactly 10 digits.');
      return false;
    }
    if (formData.alternateMobileNumber && !/^\d{10}$/.test(formData.alternateMobileNumber)) {
      //console.log('Validation failed: Alternate mobile number format incorrect.');
       toast.error('Alternate mobile number must be exactly 10 digits if provided.');
      return false;
    }
    if (!/^[A-Za-z0-9]{12}$/.test(formData.aadhaarCardNumber)) {
       toast.error('Aadhaar number must be exactly 12 alphanumeric characters.');
      return false;
    }

    if (!['Male', 'Female', 'Other'].includes(formData.gender)) {
      //console.log('Validation failed: Invalid gender selection.');
       toast.error('Please select a valid gender.');
      return false;
    }
    if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      //console.log('Validation failed: Email format incorrect.');
       toast.error('Invalid email format.');
      return false;
    }

    //console.log("All local validations passed.");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
      if (!validate()) {
        //console.log("Validation failed. Aborting submission.");
        return;
      }

      //console.log('Form Data (state) before processing for submission:', formData);

      try {
        debugger
        const submitData = new FormData();
        submitData.append('firstName', formData.firstName);
        submitData.append('lastName', formData.lastName);
        submitData.append('fatherName', formData.fatherName);
        if (formData.dateOfBirth) {
          const [year, month, day] = formData.dateOfBirth.split('-');
          submitData.append('dateOfBirth', `${day}-${month}-${year}`);
        }
        submitData.append('email', formData.email);
        submitData.append('gender', formData.gender);
        submitData.append('mobileNumber', formData.mobileNumber);
        submitData.append('alternateMobileNumber', formData.alternateMobileNumber || '');
        submitData.append('aadhaarCardNumber', formData.aadhaarCardNumber);

      //console.log("formdata:"+JSON.stringify(formData));
        if (formData.personalImage) {
          submitData.append('personalImage', formData.personalImage);
          //console.log("Appending personalImage file:", formData.personalImage.name);
        } else if (formData.imagePreview && !formData.personalImage) {
           toast.error("Please re-upload your photo if you wish to submit, as the existing photo from the server needs to be re-sent for updates.");
          //console.log("Image present in preview but not as a new File object for submission. User needs to re-upload.");
          return;
        }


        //console.log("--- Contents of FormData (submitData) for backend ---");
        for (let [key, value] of submitData.entries()) {
          if (value instanceof File) {
            //console.log(`${key}: File (Name: ${value.name}, Size: ${value.size} bytes, Type: ${value.type})`);
          } else {
            //console.log(`${key}: ${value}`);
          }
        }
        //console.log("--- End of FormData Contents ---");

        await createPersonalInfo(submitData);
        //  toast.error('Personal information saved successfully!');
        navigate(`/candidate/address-info`);
      } catch (error) {
        console.error('Error submitting personal info:', error);
        if (error.response) {
          console.error('Backend error response data:', error.response.data);
           toast.error(`Failed to save personal information: ${error.response.data.message || 'Server error'}. Please try again.`);
        } else {
           toast.error('Failed to save personal information: Network error. Please check your connection and try again.');
        }
      }
    };

  if (loading) {
    return <p>Loading personal info...</p>;
  }

  if (error) {
    return <p className="error-message">{error}</p>;
  }

  const getMaskedAadhaar = () => {
    const aadhaar = formData.aadhaarCardNumber;
    return aadhaar && aadhaar.length === 12 ? 'XXXXXXXX' + aadhaar.slice(-4) : aadhaar;
  };

  return (
    <div className="container">
      <div className="modal">
        <form className="form" onSubmit={handleSubmit}>
          <div className="grid-2col">
            <div className="inputField full-width">
              <label><FaFileUpload /> Photo*</label>
              <div
                className="dropzone"
                onDragOver={e => e.preventDefault()}
                onDrop={handleFileDrop}
                onClick={() => document.getElementById('photoInput').click()}
              >
                {!formData.imagePreview && (
                  <p>Drag & drop your photo here or click to upload</p>
                )}
                {formData.imagePreview && (
                  <div className="image-preview">
                    <img src={formData.imagePreview} alt="Uploaded preview" />
                  </div>
                )}
                <input
                  type="file"
                  id="photoInput"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={handleFileUpload}
                />
              </div>
            </div>

            <div className="inputField">
              <label><FaUser /> First Name*</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                readOnly
                required
              />
            </div>
            <div className="inputField">
              <label><FaUser /> Last Name*</label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                readOnly
                required
              />
            </div>
            <div className="inputField">
              <label><FaUser /> Father's Name/Spouse Name*</label>
              <input
                type="text"
                name="fatherName"
                value={formData.fatherName}
                onChange={handleChange}
                readOnly
              
              />
            </div>
            <div className="inputField">
              <label><FaCalendarAlt /> DOB*</label>
              <input
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
                readOnly
                required
              />
            </div>
            <div className="inputField">
              <label><FaEnvelope /> Email*</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="inputField">
  <label><FaUser /> Gender*</label>
  <div className="radioGroupHorizontal">
    <label>
      <input
        type="radio"
        name="gender"
        value="Male"
        checked={formData.gender === 'Male'}
        required
      />
      <span>Male</span>
    </label>
    <label>
      <input
        type="radio"
        name="gender"
        value="Female"
        checked={formData.gender === 'Female'}
        
      />
      <span>Female</span>
    </label>
    <label>
      <input
        type="radio"
        name="gender"
        value="Other"
        checked={formData.gender === 'Other'}
        
      />
      <span>Other</span>
    </label>
  </div>
</div>

            <div className="inputField">
              <label><FaPhone /> Mobile*</label>
              <input
                type="text"
                name="mobileNumber"
                value={formData.mobileNumber}
                onChange={handleChange}
                required
              />
            </div>
            <div className="inputField">
              <label><FaPhone /> Alternate</label>
              <input
                type="text"
                name="alternateMobileNumber"
                value={formData.alternateMobileNumber}
                onChange={handleChange}
              />
            </div>
            <div className="inputField">
              <label><FaIdCard /> Aadhaar No*</label>
              <input
                type="text"
                name="aadhaarCardNumber"
                value={getMaskedAadhaar()}
                readOnly
                required
              />
            </div>
          </div>
          <div className="submitSection">
            <button type="submit" className="submitBtn">Submit</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PersonalInfoForm;